var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialCardImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.49 29.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer_1",
    "data-name": "layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m31.78,18.85l-.06-.05c.78-.88,1.27-2.03,1.27-3.3,0-2.76-2.24-5-5-5s-5,2.24-5,5c0,1.27.49,2.42,1.27,3.3l-.06.05c-1.82,1.45-2.87,2.47-3.21,6.65,0,.54.22,1.31,1.29,1.92,1.25.72,3.48,1.09,5.71,1.09s4.45-.36,5.71-1.08c1.07-.62,1.29-1.39,1.29-2.01-.34-4.1-1.39-5.12-3.21-6.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m11.29,18.85l-.06-.05c.78-.88,1.27-2.03,1.27-3.3,0-2.76-2.24-5-5-5s-5,2.24-5,5c0,1.27.49,2.42,1.27,3.3l-.06.05c-1.82,1.45-2.87,2.47-3.21,6.65,0,.54.22,1.31,1.29,1.92,1.25.72,3.48,1.09,5.71,1.09s4.45-.36,5.71-1.08c1.07-.62,1.29-1.39,1.29-2.01-.34-4.1-1.39-5.12-3.21-6.57Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 15.99,
    cy: 5.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 18.99,
    cy: 5.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 21.99,
    cy: 5.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m26.99,5.5c0-2.76-3.58-5-8-5s-8,2.24-8,5c0,2.1,2.07,3.89,5,4.64v.36s0,2,0,2l3-2c4.42,0,8-2.24,8-5Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialCardImage);
export default __webpack_public_path__ + "static/media/social_card_image.93470f88249ebf37ccf05a35108a82b4.svg";
export { ForwardRef as ReactComponent };